import dayjs from "dayjs";
import { compact } from "lodash";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
const calendar = require("dayjs/plugin/calendar");
const MySwal = withReactContent(Swal);

dayjs.extend(calendar);

function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
}
const helpers = {
  cn: (...inputs) =>{
    return twMerge(clsx(inputs));
  },
  currencyFormat: (number = "") => {
    return new Intl.NumberFormat("en-IN", {}).format(number);
  },
  dateFormat: (date, timeZone) => {
    const convertedDate = new Date(date).toLocaleString(undefined, {
      timeZone: timeZone || "Asia/Kolkata",
    });

    return convertedDate.toString();
  },
  capitalizeFirstWord: (sentence) => {
    if (sentence) {
      return sentence?.charAt(0)?.toUpperCase() + sentence?.slice(1);
    }
    return 'N/A'
  },

  mapStyles : [
    { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
    { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#f5f5f5" }] },
    {
      featureType: "administrative.land_parcel",
      elementType: "labels.text.fill",
      stylers: [{ color: "#bdbdbd" }],
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [{ color: "#eeeeee" }],
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [{ color: "#757575" }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{ color: "#e5e5e5" }],
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9e9e9e" }],
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "#ffffff" }],
    },
    {
      featureType: "road.arterial",
      elementType: "labels.text.fill",
      stylers: [{ color: "#757575" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#dadada" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [{ color: "#616161" }],
    },
    {
      featureType: "road.local",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9e9e9e" }],
    },
    {
      featureType: "transit.line",
      elementType: "geometry",
      stylers: [{ color: "#e5e5e5" }],
    },
    {
      featureType: "transit.station",
      elementType: "geometry",
      stylers: [{ color: "#eeeeee" }],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#c9c9c9" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9e9e9e" }],
    },
  ],


  getFileORUrl: (data) => {
    if (data) {
      if (typeof data == 'string') return data
      if (typeof data !== 'string') return URL.createObjectURL(data?.[0])

    } else {
      return ''
    }

  },

  getDistanceInMeters: (loc1, loc2) => {
    if (!loc1 || !loc2) return Infinity;

    const toRad = (value) => (value * Math.PI) / 180;

    const R = 6371000; 
    const dLat = toRad(loc2.lat - loc1.lat);
    const dLng = toRad(loc2.lng - loc1.lng);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(loc1.lat)) *
      Math.cos(toRad(loc2.lat)) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; 
  },


  getTextColor: (name) => {
    if (name) {
      switch (name) {
        case 'rejected': case 'inactive': case 'cancelled': case 'canceled':
          return 'text-red-500 font-semibold'
        case 'approved': case 'completed': case "active": case "available": case "success":
          return 'text-green-500 font-semibold'
        case 'pending': case 'busy':
          return 'text-yellow-500 font-semibold'
        case 'accepted': case 'hold':
          return 'text-blue-500 font-semibold'

      }
    }
    return 'N/A'

  },
  setLocalStorage: (key, value) => {
    try {
      const jsonValue = JSON.stringify(value);
      localStorage.setItem(key, jsonValue);
    } catch (error) {
      console.error(`Error setting localStorage key "${key}":`, error);
    }
  },


  getLocalStorage: (key) => {
    try {
      const value = localStorage.getItem(key);
      return value ? JSON.parse(value) : null;
    } catch (error) {
      console.error(`Error getting localStorage key "${key}":`, error);
      return null;
    }
  },

  removeLocalStorage: (key) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`Error removing localStorage key "${key}":`, error);
    }
  },




  matchDateFormat: (dateString) => {
    if (dateString) {
      const date = new Date(dateString);
      const day = String(date.getUTCDate()).padStart(2, '0');
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const year = String(date.getUTCFullYear()).slice(-4);

      let hours = date.getUTCHours();
      const minutes = String(date.getUTCMinutes()).padStart(2, '0');

      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12;
      const strHours = String(hours).padStart(2, '0');

      return `${day}-${month}-${year} ${strHours}:${minutes} ${ampm}`;
    }
  },


  msgDateFormat: (date, timeZone) => {
    const convertedDate = new Date(date).toLocaleDateString(undefined, {
      timeZone: timeZone || "Asia/Kolkata",
    });

    return convertedDate.toString();
  },
  matchDateTime: (date, timeZone) => {
    return dayjs(date).calendar(null, {
      sameDay: "h:mm A", // The same day ( Today at 2:30 AM )
      nextDay: "[Tomorrow]", // The next day ( Tomorrow at 2:30 AM )
      nextWeek: "dddd [at] h:mm A", // The next week ( Sunday at 2:30 AM )
      lastDay: "[Yesterday at] h:mm A", // The day before ( Yesterday at 2:30 AM )
      lastWeek: "[Last] dddd [at] h:mm A", // Last week ( Last Monday at 2:30 AM )
      sameElse: "DD/MM/YYYY", // Everything else ( 17/10/2011 )
    });
  },

  getFormattedDate: (date, format) => {
    return date ? dayjs(date).format(format || 'YYYY-MM-DD') : null
  },

  marketStatus: (s) => {
    let status;
    switch (s) {
      case 1:
        status = "Open";
        break;
      case 2:
        status = "In Active";
        break;
      case 3:
        status = "Suspended";
        break;
      case 4:
        status = "Closed";
        break;
      case 9:
        status = "Ball Start";
        break;
      default:
        status = "";
    }
    return status;
  },
  getSportType: (t) => {
    let type;
    switch (t) {
      case 1:
        type = "soccer";
        break;
      case 2:
        type = "tennis";
        break;
      case 4:
        type = "cricket";
        break;

      default:
        type = "";
    }
    return type;
  },

  alertFunction: (title, item, changeFunction, deleteIcon, note) => {
    MySwal.fire({
      // title: <h3>{title}</h3>,
      html: (
        <>
          <div><strong className="">{title}</strong>{note && <><br /><p className="text-sm text-red-500 ">{note}</p></>}</div>
        </>
      ),
      icon: deleteIcon ? "error" : "question",
      showConfirmButton: "Okay",
      showCancelButton: true,
      customClass:
        "dark:bg-gray-800 border border-white dark:border-[#ffffff38]",
      showLoaderOnConfirm: true,
      preConfirm: () => {
        changeFunction(item);
      },
    });
  },


  downloadFile: (link, target) => {
    if (!link) {
      window?.alert("Invalid URL");
      return;
    }

    const parts = link.split("/");
    const filename = parts[parts.length - 1];

    const xhr = new XMLHttpRequest();
    xhr.open("GET", link, true);
    xhr.responseType = "blob";

    xhr.onload = () => {
      if (xhr.status === 200) {
        const a = document.createElement("a");
        const url = window.URL.createObjectURL(xhr.response);

        a.href = url;
        a.download = filename;
        a.target = target ? target : null

        // Append the anchor element to the body
        document.body.appendChild(a);

        // Programmatically click the anchor element
        a.click();

        // Remove the anchor element from the body
        document.body.removeChild(a);

        // Revoke the object URL to free up resources
        window.URL.revokeObjectURL(url);
      } else {
        window?.alert(`Failed to download file. Status: ${xhr.status}`);
      }
    };

    xhr.onerror = () => {
      window?.alert("Failed to download file. Check the URL and try again.");
    };

    xhr.send();
  },

  generatePassword: async (length) => {
    const passwordLength = length;
    const numberChars = "0123456789";
    const upperChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const lowerChars = "abcdefghijklmnopqrstuvwxyz";
    const specialChars = "#?@$%&";
    const allChars = numberChars + upperChars + lowerChars + specialChars;
    let randPasswordArray = Array(passwordLength);
    randPasswordArray[0] = numberChars;
    randPasswordArray[1] = upperChars;
    randPasswordArray[2] = lowerChars;
    randPasswordArray[3] = specialChars;
    randPasswordArray = randPasswordArray.fill(allChars, 4);
    return shuffleArray(
      randPasswordArray.map(function (x) {
        return x[Math.floor(Math.random() * x.length)];
      })
    ).join("");
  },

  requiredField: async () => {
    return <span className="text-red-500">*</span>;
  },

  getSeconds: (dateStr1, dateStr2) => {
    const date1 = dayjs(dateStr1);
    const date2 = dayjs(dateStr2);

    // Get the difference in seconds
    return compact([date2.diff(date1, "second")])[0];
  },
  getDateAndTime: (date) => {
    return dayjs(date).format("MM/DD/YYYY hh:mm A");
  },
  preventForNumberInput: (e) => {
    if (["-", "+", "e"].includes(e.key)) {
      e.preventDefault();
    }
    if (["."].includes(e?.target?.value)) {
      const afterDecimal = e?.target?.value?.split(".");
      if (afterDecimal[1]?.length > 2) {
        e.preventDefault();
      }
    }
  },
  ternaryCondition: (condition, first, second) => {
    return condition ? first : second;
  },
  andOperator: (condition, text) => {
    return condition && text;
  },
  orOperator: (condition, text) => {
    return condition || text;
  },
  getFullName: (firstName, lastName) => {
    return compact([firstName, lastName]).join(" ");
  },
  formattedAmount: (amount) => {
    return amount?.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      currencyDisplay: "symbol",
    });
  },
  formattedAmountEURO: (value) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "EUR",
    }).format(value);
  },
  formattedAmountDynamic: (value, currency) => {
    if (currency === "GBP") {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "GBP",
      }).format(value);
    } else if (currency === "EUR") {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    }
    return "";
  },
  formateNull: (text) => {
    let result = "";
    if (text) {
      result = text;
    }
    return result;
  },


  getMatchStatus: (status) => {
    switch (status) {
      case 'Live':
        return 'text-blue-600 font-bold';
      case 'Not Started':
        return 'text-yellow-400 font-bold';
      case 'Finished': case 'In Progress':
        return 'text-green-600 font-bold';
      case 'Cancelled': case 'Canceled':
        return 'text-red-600 font-bold';
      case 'Delayed':
        return 'text-[#ec9630] font-bold';
    }
  },

  turboConsole: (message, data) => {
    return console.log(
      `%c ${message || ''}, ${data || ''}`, "color: white; font-size: 16px; background: red");
  },
  normalizeSpaces: (str) => {
    return str?.replace(/\s+/g, ' ')?.trim();
  },
  CheckOnlySpace: (value, message) => {
    if (value?.length > 0 && value?.trim().length == 0) {
      return message ?? "This field cannot be only spaces"
    }
    return true
  },

  

};

export default helpers;
